import React, { useState } from "react";
import axios from "axios";

const SuperAdminDashbaord = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);

  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setPage(1);

    if (!fromDate || !toDate) {
      setError("Please select both dates");
      return;
    }

    try {
      const res = await axios.post(`${backendUrl}course-payments-from-to-superadmin`, {
        from_date: fromDate,
        to_date: toDate,
      });

      if (res.data.success) {
        setResult(res.data.data);
      } else {
        setError("No data found");
      }
    } catch {
      setError("Something went wrong, try again later.");
    }
  };

  const records = result?.day_wise_summary || [];
  const recordsPerPage = 10;
  const startIndex = (page - 1) * recordsPerPage;
  const paginatedRecords = records.slice(startIndex, startIndex + recordsPerPage);
  const totalPages = Math.ceil(records.length / recordsPerPage);

  return (
    <div className="container-fluid">
      {/* <h2 className="text-center fw-bold mb-4">Admin Dashboard</h2> */}

      {/* Date Form */}
      <form
        onSubmit={handleSubmit}
        className="p-4 rounded-4 shadow-sm bg-light mb-3"
        style={{ maxWidth: 600, margin: "auto" }}
      >
        <h5 className="fw-semibold mb-3">Select Date Range</h5>
        <div className="d-flex gap-3 align-items-end">
          <div className="flex-fill">
            <label className="form-label small fw-semibold">Start Date</label>
            <input type="date" className="form-control" value={fromDate}
              onChange={(e) => setFromDate(e.target.value)} />
          </div>
          <div className="flex-fill">
            <label className="form-label small fw-semibold">End Date</label>
            <input type="date" className="form-control" value={toDate}
              onChange={(e) => setToDate(e.target.value)} />
          </div>
          <button className="btn btn-primary px-4" type="submit">
            Submit
          </button>
        </div>
      </form>

      {error && <p className="text-danger text-center mt-2">{error}</p>}

      {/* Data Section */}
      {result && (
        <div className="bg-white rounded-4 shadow-sm p-4">
          <h5 className="fw-bold text-dark mb-3">
            Summary: {result.date_range.from_date} → {result.date_range.to_date}
          </h5>

          {/* Summary numbers */}
          <div className="row text-center mb-4">
            <div className="col">
              <p className="fw-bold mb-0">{result.overall_summary.total_payments_amount}</p>
              <small>Total Payments</small>
            </div>
            <div className="col">
              <p className="fw-bold mb-0">{result.overall_summary.total_refunds_amount}</p>
              <small>Total Refunds</small>
            </div>
            <div className="col">
              <p className="fw-bold mb-0 text-success">{result.overall_summary.net_amount_in_cashcounter}</p>
              <small>Net Amount</small>
            </div>
          </div>

          {/* Table */}
          <table className="table table-bordered table-striped">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Date</th>
                <th>Payments Count</th>
                <th>Refund Count</th>
                <th>Payments Total</th>
                <th>Refund Total</th>
                <th>Net Amount</th>
              </tr>
            </thead>
            <tbody>
              {paginatedRecords.map((day, index) => (
                <tr key={day.date}>
                  <td>{startIndex + index + 1}</td>
                  <td>{day.date}</td>
                  <td>{day.summary.total_payments_count}</td>
                  <td>{day.summary.total_refunds_count}</td>
                  <td>{day.summary.total_payments_amount}</td>
                  <td>{day.summary.total_refunds_amount}</td>
                  <td className={day.summary.net_amount_in_cashcounter >= 0 ? "text-success" : "text-danger"}>
                    {day.summary.net_amount_in_cashcounter}
                  </td>
                </tr>
              ))}
              {!paginatedRecords.length && (
                <tr>
                  <td colSpan="7" className="text-center text-muted">No records found</td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Pagination */}
          {records.length > 0 && (
            <div className="d-flex justify-content-between align-items-center">
              <span className="text-muted small">
                Page {page} of {totalPages}
              </span>
              <div className="d-flex gap-2">
                <button className="btn btn-outline-secondary btn-sm"
                  disabled={page === 1} onClick={() => setPage(page - 1)}>
                  Prev
                </button>
                <button className="btn btn-outline-secondary btn-sm"
                  disabled={page === totalPages} onClick={() => setPage(page + 1)}>
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SuperAdminDashbaord;
